const common = {
  between: "Between",
  and: "and",
  all: "All",
  action: "Action",
  active: "Active",
  add: "Add",
  address: "Address",
  agencies: "Offices",
  agency: "Office",
  attachment: "Application for Payment",
  attachments: "Applications for Payment",
  amount: "Amount",
  bpu: "Rate Card",
  bpuTemplates: "Rate Card Templates",
  cancel: "Cancel",
  category: "Category",
  close: "Close",
  code: "Code",
  city: "Town",
  comment: "Comment",
  commentUpdated: "Comment updated",
  commentUpdateFailed: "Comment update failed",
  comments: "Comments",
  company: "Company",
  connection: "Log in",
  contactInformation: "Mailing address",
  contractor: "Contractor",
  contractorAgreement: "Contractor Agreement",
  create: "Create",
  createDelegation: "Create a delegation",
  creation: "Creation",
  creator: "Creator",
  currency: "Currency",
  currentCurrency: "GBP",
  date: "Date",
  dashboard: "Dashboard",
  deletion: "Deletion",
  deposits: "Deposits",
  depositType: "Retention",
  description: "Description",
  designation: "Description",
  disconnect: "Log out",
  accountManage: "Gérer le compte",
  dgd: "Final account",
  dsp: "DSP",
  director: "Director",
  display: "Display",
  documents: "Documents",
  download: "Download",
  edifice: "Internal contract reference",
  edition: "Edit",
  elements: "Elements",
  email: "E-Mail",
  endDate: "End date",
  envelopes: "Envelopes",
  eotp: "WBS element",
  eur: "EUR",
  exporter: "Export",
  generate: "Generate",
  help: "Help",
  id: "Id",
  import: "Import",
  imputation: "Cost allocation",
  imputations: "Cost allocations",
  includingDepositUsed: "Including caution",
  information: "Information",
  legalEntity: "Legal entity",
  mail: "Mail",
  manager: "Managing Director",
  market: "Subcontractors markets",
  menu: "Menu",
  milestone: "Milestone",
  name: "Name",
  noFilter: "No filter",
  next: "Next",
  node: "Node",
  nro: "POP",
  number: "Number",
  object: "Object",
  objects: "Objects",
  observation: "Observation",
  on: "on",
  onDate: "on",
  options: "Options",
  oracleCode: "Oracle Code",
  oracle_projects: "Oracle projects",
  order: "Order",
  orders: "Orders",
  payment: "Payment",
  permissions: "Permissions",
  phone: "Phone number",
  pm: "FDH",
  prestations: "Rate Card Item",
  previous: "Previous",
  profile: "Profile",
  project: "Project",
  projects: "Projects",
  quality: "Role",
  quantity: "Quantity",
  quantitatives: "Quantities",
  rad: "RAD",
  reference: "Reference",
  responsible: "Responsable",
  retention: "Retention",
  retentions: "Retentions",
  rg: "Retention",
  role: "Role",
  sap: "SAP",
  save: "Save",
  selection: "Selection",
  send: "Send",
  service: "Service",
  siren: "Company number",
  siret: "Office number (France)",
  startDate: "Start date",
  status: "Status",
  subcategory: "Sub-category",
  template: "Template",
  to: "to",
  total: "Total",
  transitions: "Transitions",
  type: "Type",
  unit: "Unit",
  upload: "Upload",
  users: "Users",
  vat: "VAT",
  validate: "Validate",
  validator: "Validator",
  visibility: "Visibility",
  workflow: "Workflow",
  contracts: "Contracts",
  preview: "Preview",
  delete: "Delete",
  noRecords: "No records",
  evaluation: "Evaluation",
};

const expressions = {
  accessNotGranted: "You don't have the rights to access to this page",
  addDocument: "Add a document",
  addedOn: "Added on",
  comment: "Comment",
  contractName: "Contract name",
  createdAt: "Created at",
  creationDate: "Creation date",
  delete: "Do you really want to delete this element?",
  deleteDocument: "Do you really want to delete this document?",
  deleteContract:
    "Do you really want to delete this contract and its related envelopes, documents, validators, and workflow histories?",
  deactivateContract:
    "This action is irreversible: the contract and its ST markets will be permanently deactivated. Continue?",
  reactivateContract:
    "Do you want to reactivate this contract? Linked ST markets will remain inactive and must be reactivated separately.",
  deleteEnvelope:
    "Do you really want to delete this envelope and its related documents, validators, and workflow histories?",
  disableAllEvaluations:
    "Do you really want to disable evaluations on all subcontractor markets?",
  enableAllEvaluations:
    "Do you really want to enable evaluations on all subcontractor markets?",
  endDate: "End date",
  fetchingError: "Error when fetching data",
  fileName: "File name",
  keepProfile: `You are connected on another tab as {0}, do you want to continue with this profile?`,
  leaveWithoutSaving:
    "Do you really want to leave this page without saving your changes?",
  mustBeAfter: "The date must be after the payment notice's date",
  myTasks: "My tasks",
  myScope: "My scope",
  noAccessToEntity: "You don't have access to this entity",
  noReadAccessToEntity: "You don't have reading access to this entity",
  noAttachment: "No Application for Payment",
  noData: "No data to display",
  noFileSelected: "You haven't selected any file",
  noDocumentTypleSelected: "You haven't selected any document type",
  noPrestation: "No Rate Card Item",
  noUser: "No User",
  problemDescription: "Description of the issue",
  projectName: "Project name",
  projectConcerned: "Project concerned",
  selectFile: "Select a file",
  selectAttachment: "Select an attachment",
  selectedAttachmentName: "Name of the selected attachment",
  selectedFileName: "Selected file name",
  startDate: "Start date",
  templateName: "Template name",
  reportIncidentToSupport: "Report an incident to support",
  reportIncident: "Report an incident",
  triggeredBy: "Triggered by",
  userManuals: "Modes opératoires",
  deactivate: "Are you sure to deactivate this element ?",
  activate: "Are you sure to activate this element ?",
  validationDate: "Validation date",
};

const entities = {
  agency: "Office",
  agencies: "Offices",
  attachment: "Application for Payment",
  attachments: "Applications for Payment",
  bpu: "Rate Card",
  bpus: "Rate Cards",
  bpuTemplate: "Rate Card template",
  bpuTemplates: "Rate Card templates",
  company: "Company",
  companies: "Companies",
  contractorAgreement: "Contractor Agreement",
  contractorAgreements: "Contractor Agreements",
  contractTemplate: "Contract templates",
  contractTemplates: "Contract templates",
  documentType: "Type of document",
  documentTypes: "Types of document",
  notifications: "Notifications",
  oracleProject: "Oracle Project",
  oracleTask: "Oracle Task",
  oscarProject: "OSCAR Project",
  oscarProjects: "OSCAR Projects",
  oscarSubProject: "OSCAR Sub-project",
  oscarSubProjects: "OSCAR Sub-projects ",
  order: "Order",
  orders: "Orders",
  orderTemplate: "Order template",
  orderTemplates: "Order templates",
  paymentGuarantee: "Payment guarantee (France)",
  paymentGuarantees: "Payment guarantees (France)",
  prestation: "Rate card item",
  prestations: "Rate card items",
  prestationReference: "Reference of Rate card item",
  prestationReferences: "References of Rate card item",
  prestationType: "Type of Rate card item",
  prestationTypes: "Types of Rate card item",
  projectType: "Type of projet",
  projectTypes: "Types of projet",
  role: "Role",
  roles: "Roles",
  situation: "Payment Notice",
  situations: "Payment Notices",
  unit: "Unit",
  units: "Units",
  user: "User",
  users: "Users",
  vat: "VAT rate",
  vats: "VAT rates",
  workflowNode: "Workflow node",
  contract: "Contract",
};

const login = {
  title: "Interface de Suivi Financier",
  username: "Username",
  password: "Password",
  forgotPassword: "Forgot your password?",
};

const home = {
  nothingToValidate: "No Order, Application for Payment or Subcontractor Market to validate.",
  myOrders: "My orders to process",
  myAttachments: "My Applications for Payment to process",
  myMarkets: "My subcontractors to process",
  workflowProcess: "Workflow to process",
  ongoingWork: "Work in progress",
  ongoingOrders: "On-going orders with an outstanding amount of ",
};

const agencies = {
  addUser: "Add a user",
  agencyCreation: "Creation of an Office",
  anomalies:
    "Anomaly in the agency, incomplete document, collective proceeding or the agency is closed.",
  inviteMailHint:
    "This mail must be the one from the subcontractor to receive the subscription and reminders.",
  columns: {
    agencyCode: "Office code",
    address: "Office address",
    manager: "Managing Director",
    edifice: "Office",
    isActive: "Active",
    inviteMail: "Invite mail",
  },
  administrativeDocuments: "Administrative documents",
  nolegalDocuments: "No documents have been retrieved from e-attestation.",
};

const attachments = {
  exportBPU: "Export (All)",
  unrecordedBenefits: "No Rate Card Item",
  amountWoVat: "Amount (excl. VAT)",
  wfStatus: "Workflow status",
  cumulativePreviousAmount: "Cumulative previous amount (excl. VAT)",
  cumulativeAmount: "Cumulative amount (excl. VAT)",
  currentPeriodAmount: "Current period amount (excl. VAT)",
  completionDate: "Completion date",
  totalAmount: "Total order amount (excl. VAT)",
  observationCMD: "Comments (Order)",
  finalBilling: "Décompte définitif",
  evaluation: "Evaluation",
  resendToOracle: "Envoyer dans Oracle",

  prestationColumns: {
    orderQuantity: "Quantity ordered",
    orderAmount: "Amount ordered",
    cumulativeQuantity: "Cumulative quantities",
    cumulativeAmount: "Cumulative amount",
    cumulativePreviousQuantity: "Previous quantities",
    cumulativePreviousAmount: "Previous amount",
    currentQuantity: "Current period quantities",
    currentAmount: "Current period amount",
    help: "Previous + current quantities. The quantities of the next applcations for payment are not accounted here.",
    helpTwo:
      'Quantities of applications for payment with the "Sent for validation" date before the current one.',
  },

  attachmentCreation: "Creation of an Application for Payment",
  validatedOrders: "Validated orders list",
  sameMonthAttachment:
    "You already have an application for payment for this month. Do you want to proceed?",
  dgdAlreadyExists:
    "A final account (DGD) already exists on this order. Please create a new order.",
  prestationSelection: "Rate Card Items selection",
};

const bpus = {
  bpuCreation: "Rate Card Creation",
};

const bpuTemplates = {
  bpuTemplateCreation: "Rate Card Template Creation",
};

const categories = {
  parentCategory: "Parent category",
  mergeDuplicates: "Merge duplicates",
  categoryCreation: "Creation of a category",
};

const companies = {
  agencyCreation: "Office Creation",

  companyCreation: "Company Creation",
  columns: {
    edificeCode: "SAP code",
  },
};

const contractTemplates = {
  addContractTemplate: "Add a contract template",
  downloadContractTemplate: "Download a contract template",
  contractTemplateName: "Contract template name",
};

const dc4 = {
  title: "Suivi des DC4",
  attachmentsPaid: "Montant Attachements Payés",
  readyToPayAttachments: "Montant Attachements Situation Mensuelle",
  validatedAttachments: "Montant Attachements Validés",
  allAttachments: "Montant HT Attachements validés/situation mensuelle/payés",
  availableDC4: "Disponible sur DC4",
  availableDC4WithRad: "Disponible sur DC4 avec RAD",
};

const deposits = {
  type: "Type",
  typeMarket: "Market",
  typeOrder: "Order",
  depositAmount: "Deposit amount",
  depositUsed: "Amount bond",
  amountLeft: "Amount left",
  reimbursementDate: "Reimbursement date",
  addDeposit: "Add a deposit",
};

const envelopes = {
  addEnvelope: "Add envelope",

  validation: {
    sendToValidation: "Send to validation",
    atLeast2RolesRequired:
      "At least two validator profiles are required, please contact an administrator",
    eachRoleMustSelectAUser: "Please associate a user for each role",
    validatorSelectionModalTitle: "Validators selection",
  },

  signature: {
    sendForSignature: "Send for signature",
    signersModalTitle: "Signers info",
    axioneSide: "Axione",
    contractorSide: "Contractor",
    signaturePosition: "Signature placement",
    anchorString: "Placement anchor",
    positionHelper:
      "On manual mode signers place themselves their signatures on the document.\nOn automatic mode, the signature is placed on an anchor (text).\nThe placement anchors must have the same document background color to be invisible on the final document.",
    anchorStingsShouldBeDifferent: "The placement anchors must be different",
    successfullySent: "Contract successfully sent for signature",
    failedSent: "An error occured when sending the documents for signature",
  },
  none: "No envelope",
};

const documentTypes = {
  documentTypeCreation: "Document Type Creation",
};

const markets = {
  nbAttachments: "Number of Applications for payment",
  currentBpu: "Current Rate card",
  marketCreation: "Creation of a contractor agreement",
  deactivate: "Deactivate",
  activate: "activate",

  columns: {
    agencyCode: "Name",
    edifice: "Name",
    contractNumber: "Contract number",
    dateEndOfContract: "Contract expiry date",
    eotpSt: "Contractor WBS",
    marketNumber: "SAP number",
    maxAmountDC4: "Max DC4 Amount (France)",
    paymentCondition: "Payment terms",
    paymentType: "Payment type (France)",
    billingMandate: "Billing mandate",
    thresholdAmount: "Threshold amount (France)",
    vatType: "VAT Category",
    activated: "Activated",
  },
  vatTypes: {
    basic: "20%",
    tenPercents: "10%",
    reverseCharge: "Reverse charge",
  },
};

const notifications = {
  refus: "You must justify the refusal.",
  min: "(5 characters minimum).",
};

const ods = {
  title: "Manual Cost allocation template",
  situationDate: "Payment Notice Date",
  attSubcontractor: "Application for Payment Reference",
  senderEotp: "Sender WBS Element",
  receiverEotp: "Receiver WBS Element",
  amount: "Amount excl. VAT",
  accountingNature: "Cost element",
};

const oscarSubProjects = {
  constructionBaseQuantities: "Quantities Construction GIS database",

  columns: {
    subProjectYear: "Sub-project's Year",
    subProjectCity: "Sub-project's Town",
    subprojectStatus: "Sub-project's status",
    arcgisName: "Arcgis Name",
    oscarSubProject: "OSCAR Sub-project",
    arcgisReference: "Arcgis Reference",
    oiCode: "Code OI (France)",
    marketType: "Project type",
    projectName: "Project Name",
    subProjectName: "Sub-project name",
    nroName: "POP Name",
    nroIpeId: "POP Name",
    pmIpeId: "FDH name",
    pmOfferId: "FDH number",
    pmAxioneId: "Project Reference",
    pmCity: "FDH's Town",
  },
};

const orders = {
  releaseSituation: "Rentention's Payment Notice",
  wfStatus: "Workflow status",
  displayAllPrestations: "Display all items of the Rate Card",
  totalPrestation: "Total amount",
  invoiced: "Previously Notified",
  releaseDate: "Retention release date",
  needMarket: "Needs a contractor agreement",
  orderCreation: "Creation of an order",
  resendToOracle: "Resend to Oracle",
  syncOracleStatus: "Refresh Oracle status",
  syncOracleStatusConfirm: "Refresh the order status from Oracle?",
  syncOracleStatusFailed: "Failed to sync Oracle status",

  columns: {
    edifice: "Internal contract reference",
    contractNumber: "Contract Number",
    complement: "Details",
    clientMarket: "Client Agreement (France)",
    completionDate: "Completion date",
    deliveryDuration: "Delivery duration",
    bdcCustomer: "Client order (France)",
    managedBy: "Managed by",
    mainClient: "Main client (France)",
    orderManagedBy: "Managed by",
    sstMarket: "Contractor Agreement",
    deliveryDate: "Network Acceptance Document",
  },
};

const orderTemplates = {
  switchAll: "Tout ouvrir/fermer",
  templateCreation: "Order Template Creation",
};

const paymentGuarantees = {
  fieldNamesMustBeInList:
    "The names of the form fields must be in the following list:",
  addGuarantee: "Add a Payment Guarantee",
};

const prestations = {
  needCategory: "Needs a category",
  prestationCreation: "Rate card item creation",

  columns: {
    unitPrice: "Unit price",
    itemCode: "Item code",
  },
};
const prestationReferences = {
  prestationReferenceCreation: "Reference of Rate card item creation",
};

const prestationTypes = {
  prestationTypeCreation: "Type of Rate card item creation",
};

const projects = {
  nbOrdersValidated: "Orders validated and/or closed",
  nbAttachmentsPaid: "Applications for payment paid",
  sumOrdersValidated: "Cumulative amount of Orders validated and/or closed",
  sumAttachmentsPaid: "Cumulative amount paid",
  imputationCreation: "Creation of a Cost allocation",
  editImputation: "Edit a cost allocation",
  addUserToProject: "Add a utilisateur to a projet",
  monthlyGenerationDay: "Payment Notice issuance date",
  shareFiles: "Partager les attachements dans Sharepoint",

  projectCreation: "Project Creation",
  directorAddress: "Mailing address",
  columns: {
    manager: "Project Director",
  },
  oracleProjectCreation: "Oracle project association",
};

const projectTypes = {
  projectTypeCreation: "Project Type creation",
};

const quantitatives = {
  quantityOrdered: "Quantity ordered",
  cumulatedQuantity: "Cumulated quantity delivered",
  orderedAmount: "Ordered amount",
  cumulativeAmount: "Cumulated amount ordered",
};

const roles = {
  roleCreation: "Role creation",
  additionalPermissions: "You can set additional permissions on this role.",
  parentRole: "Parent role",
  visibilities: {
    all: "Access to all elements of the database",
    projects: "Access limited to user's projets",
    managerProjects: "Access limited to the projects of the user's manager",
    projectsOffices: "Access limited to user's projets and user's offices",
  },
};

const situations = {
  markPaid: "Mark paid",
  cancelPayment: "Cancel payment",
  attachmentNo: "Application for Payment number",
  releasedAmount: "Retention release amount (excl. VAT)",
  sapReference: "SAP Contract number",
  theoreticalPaymentDate: "Final date for payment",
  currentMonthAmount: "Monthly amount (excl. VAT)",
  rgAmount: "Retention amount (excl. VAT)",
  bondAmount: "Bond amount",
  withheldAmount: "Withheld amount",
  amountWoRg: "Amount without Retention (excl. VAT)",
  totalAmountWoVat: "Total amount (excl. VAT)",
  vatAmount: "VAT amount",
  reverseChargeAmount: "Reverse charge VAT amount",
  totalAmount: "Total amount (incl. VAT)",
  releaseSituation: "Payment notice with released retention",
  releaseDate: "Retention release date",
  totalWoVat: "Total (excl. VAT)",
  totalWithVat: "Total (incl. VAT)",
  situationCreation: "Create a Payment Notice",
  projectSelection: "Projects selection",
};

const vats = {
  creation: "Create VAT rate",
  amount: "Rate (%)",
};

const units = {
  unitCreation: "Creation of unit",
};

const users = {
  changePerimeter: "Change scope",
  projectType: "Project type",
  secondaryProfiles: "Additional profiles",
  assignPerimeterToUser: "Assign scope to another user",
  authorizationAmount: "Limit authorisation",
  mainProfile: "Main Profile",
  addUser: "User creation",
  ldapCommonName: "LDAP CommonName",
  columns: {
    manager: "Line manager",
  },
};

const warranties = {
  title: "Retention Monitoring",
  depositType: "Retention/Bond",
  attachementAmount: "Validate Applications for payment amount",
  totalRetention: "Retention amount",
  releasedAmount: "Retention released amount",
  remainingAmount: "Retention amount to be released",
  bondAmount: "Retention bond amount",
  withheldAmount: "Retention withheld amount",

  orderReference: "Référence commande",
  orderEndDate: "Order end date",
  deliveryDate: "Network Acceptance Document",
  releaseDate: "Retention release date",
  attAmount: "Applications for Payment total amount",
  attAmountHelp: "Validated + Noticed + Paid",
  rgHelp: "Retention",
  bondRg: "Retention bond",
  bondRgHelp: "Amount used on a deposit",
  withheldRg: "Retention withheld",
  rgReleased: "Retention released",
  rgReleasedHelp: "Retentions released in a Payement notice",
  rgToRelease: "Retention to be released",
  rgToReleaseHelp: "Retenions left to be released in a Payement notice",
  retentionTypes: {
    basic: "Retention",
    withThreshold: "Retention with threshold",
    nonApplicable: "Non applicable",
  },
  hideEmptyRG: "Hide empty lines",
  hideOracle: "Hide Oracle RG",
};

const errors = {
  many2OneField: {
    selectItem: "The field {field} is mandatory",
  },
};

const account = {
  myAccount: "Mon compte",
  delegation: {
    delegations: "My delegations",
    noDelegation: "You didn't set-up any rights delegation",
    delegationCreation: "Create a delegation",
    delegateTo: "Delegate to",
    receivedDelegations: "Received delegations",
    noReceivedDelegation: "No delegation received",
    delegateFrom: "Delegation from",
    userToDelegate: "User to delegate",
    userDelegated: "User receiving the delegation",
    userDelegations: "User's delegations",
    userNoDelegation: "The user didn't setup any rights delegation.",
    userNoReceivedDelegation: "The user didn't receiving any delegations.",
    byDelegationOf: "by delegation of",
  },
};

const contract = {
  contractNumber: "Contract number",
  parentContract: "Parent Contract",
  contractType: "Contract type",
  signatureDate: "Signature date",
  startDate: "Start date",
  endDate: "Expiration date",
  duration: "Duration",
  terminationDate: "Termination date",
  expirationDateAfterRenewal: "Expiration date after renewal",
  referent: "Referent",
  referentOracle: "Oracle referent",
  adminReferent: "Admin referent",
  active: "Active",
  contractCreation: "Contract creation",
  contractChild: "Childs contracts",
  noChildContracts: "No child contracts.",
};

const popup = {
  tabs: {
    content: "Popup content",
    users: "Users",
    information: "Information",
  },
  addUsers: "Add users",
  removeUsers: "Delete users",
  readedAt: "Read",
  closedAt: "Closed",
};

const evaluation = {
  companies: "Companies",
  agencies: "Agencies",
  contracts: "Contracts",
  projects: "Projects",
  subcontractorsMarkets: "Subcontractors markets",
  evaluation: "Evaluation",
  enableAllEvaluation: "Enable all evaluations",
  disableAllEvaluation: "Disable all evaluations",
  rating: "Rating",
  comment: "Comment",
  safetyTitle: "Safety evaluation",
  procurementTitle: "Procurement evaluation",
  projectTitle: "Project Evaluation",
  type: "Type",
  procurement: "Procurement",
  project: "Project",
  document: "Document",
  search: "Search",
  averageRatings: "Average rating",
  averageRating: "Average rating",
  ratingDate: "Rating date",
  agencyNumber: "Agency number",
  ratingNumber: "Rating number",
  gaugeRadar: "Ratings Radar",
  companyList: "Company list",
  submit: "Submit",
  feedbackWarning: "Please provide feedback for a rating below 3.",
  deleteEvaluation: "Confirm deletion of evaluation?",
  helper: {
    intro:
      "Rate each criterion on a scale of 1 to 5 stars. A comment is required for ratings below 3 stars.",
    commentRequired: "Please explain your evaluation (required)",
    commentOptional: "Comment (optional)",
    errorMessage: "Please provide a comment for ratings of 2 stars or less.",
    skipLabel:
      "Check this box if you have already evaluated, or cannot evaluate this attachment",
  },

  buttons: {
    submit: "Submit",
    cancel: "Cancel",
    skip: "Skip",
  },
  quality: {
    label: "Quality rating",
    specs: "Specifications compliance",
    materials: "Services / materials quality",
    controls: "Self-checks / Test mastery",
    compliance: "DOE compliance / collection",
    installation: "Ease of installation or use by the site (suppliers)",
    packaging: "Packaging / Conditioning (suppliers)",
    execution: "Compliance in service or supply execution",
    incidents: "Transparency in reporting malfunctions (incidents/accidents)",
    value: "Quality/price ratio",
  },
  technical: {
    label: "Technical rating",
    studies: "Technical studies",
    plans: "Execution plans reliability",
    aptitude: "Technical ability to meet requirements",
    proposition:
      "Proactive proposals - variants / autonomy (design office existence)",
    innovation: "Innovation",
    qualification: "Technical staff qualification / Given advice / Supervision",
    assistance: "Technical support availability",
    organization: "Site organization",
    responses: "Quality of tender responses",
  },
  deadlines: {
    label: "Deadlines rating",
    offers: "Deadlines compliance",
    intervention: "Resources implemented",
    reactivity: "Responsiveness",
    availability: "Logistics",
    contractual: "Contractual deadlines compliance",
    commitments: "Commitments compliance",
  },
  safety: {
    label: "Safety",
    rules: "Safety Indicators from Inspections",
    regulations:
      "Evaluation every six months by prevention officers based on audits conducted on sites with operational staff",
  },

  rse: {
    label: "CSR Rating",
    environment: "Environmental requirements compliance",
    waste: "Waste management and disposal in proper treatment channels",
    impact: "Environmental impact of the product (suppliers)",
    packaging: "Packaging / Storage of hazardous products (suppliers)",
    transparency:
      "Transparency in reporting malfunctions (incidents/accidents)",
    ethics: "AXIONE code of ethics compliance",
    standards: "Labor standards compliance",
    performance: "CSR Performance",
    insertion: "Insertion",
  },
  relational: {
    label: "Relational Rating",
    quality: "Relationship quality",
    communication: "Communication quality",
    responses: "Quality of consultation responses",
    procedure: "Administrative procedure compliance (e.g., certifications)",
    billing: "Billing / situation compliance",
    disputes: "Disputes",
    attendance: "Meeting attendance",
    commercial: "Commercial efficiency",
    payment: "PQFA Payment",
  },
};

const oraclePoStatus = {
  null: "Not set",
  NON_CONCERNED: "Not concerned",
  NOT_SENT: "Not sent",
  SENDING: "Sending",
  ERROR: "Error",
  SYNCHRONIZED: "Synchronized",
  INCOMPLETE: "Incomplete",
  OPEN: "Open",
  CLOSED: "Closed",
  FINALLY_CLOSED: "Finally closed",
  CANCELED: "Canceled",
  PENDING_APPROVAL: "Pending approval",
  IN_PROCESS: "In process",
};

const oracle = {
  rgWarranties: {
    errorModal: "Report an error",
    reportError: "Report an error",
    successModal: "Release of RG/Warranties",
    invoiceName: "Invoice name",
    report: "Report",
    status: "Status",
    statusReason: "Comment",
  },
  synchronizeProjects: "Synchronize projects",
};

const attachementStatus = {
  att_draft: "In creation",
  att_validation_sst: "In validation SST",
  att_validating: "In validation technique",
  att_validating_amount: "In validation financial",
  att_validated: "Validated",
  att_prepared_for_payment: "Monthly statement",
  att_paid: "Paid",
  att_refused: "Refused",
};

const orderItems = {
  title: "Attached items",
  filters: {
    tokenStartDate: "Start date",
    tokenEndDate: "End date",
    subcontractorMarket: "Subcontractor",
  },
  columns: {
    attachementReference: "Attachment reference",
    status: "Attachment status",
    tokenCreatedAt: "Status date",
    orderReference: "Order reference",
    agencyName: "Agency name",
    subcontractorMarket: "Subcontractor",
    project: "Project",
    oracleProject: "Oracle Project",
    oracleTask: "Oracle Task",
    sapReference: "SAP Contract number",
    siret: "SIRET",
    prestationCode: "Service code",
    designation: "Designation",
    unit: "Unit",
    unitPrice: "Unit price",
    prestationQuantity: "Ordered quantity",
    orderedAmount: "Ordered amount",
    amount: "Attachment amount",
  },
};

export default {
  agencies,
  attachments,
  bpus,
  bpuTemplates,
  categories,
  common,
  companies,
  contractTemplates,
  dc4,
  deposits,
  documentTypes,
  entities,
  expressions,
  home,
  login,
  markets,
  notifications,
  ods,
  orders,
  orderTemplates,
  oscarSubProjects,
  paymentGuarantees,
  prestations,
  prestationReferences,
  prestationTypes,
  projects,
  projectTypes,
  quantitatives,
  roles,
  situations,
  vats,
  units,
  users,
  warranties,
  errors,
  account,
  contract,
  popup,
  evaluation,
  envelopes,
  oraclePoStatus,
  oracle,
  attachementStatus,
  orderItems,
};
